import {toast} from '@wandb/weave/common/components/elements/Toast';
import {Icon, IconName} from '@wandb/weave/components/Icon';
import copyToClipboard from 'copy-to-clipboard';
import React from 'react';

import {Analytics} from '../../services/analytics';
import * as S from './ShareLinks.styles';

type ShareLinkContent = {
  name?: string;
  label: string;
  icon: IconName;
  getLink?: (linkStr: string) => string;
};

const LINKS: ShareLinkContent[] = [
  {
    name: 'twitter',
    label: 'Share on Twitter',
    icon: 'twitter',
    getLink: linkStr =>
      `http://twitter.com/share?text=${encodeURIComponent(
        'Check out my results on @weights_biases'
      )}&url=${encodeURIComponent(linkStr)}&hashtags=wandb`,
  },
  {
    name: 'linkedin',
    label: 'Share on LinkedIn',
    icon: 'linkedin-social',
    getLink: linkStr =>
      `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(
        'Check out my results on @Weights & Biases '
      )}${encodeURIComponent(linkStr)}%20%23wandb`,
  },
  {
    name: 'reddit',
    label: 'Share on Reddit',
    icon: 'reddit-social',
    getLink: linkStr =>
      `http://www.reddit.com/submit?url=${encodeURIComponent(
        linkStr
      )}&title=${encodeURIComponent(
        'Check out my results on Weights & Biases'
      )}`,
  },
  {
    label: 'Copy embed code',
    icon: 'code-alt',
  },
];

type LinkBoxProps = {
  link: string;
  reportId: string;
  setShouldDeleteView: (b: boolean) => void;
} & ShareLinkContent;
export const LinkBox = ({
  icon,
  label,
  getLink,
  link,
  name,
  reportId,
  setShouldDeleteView,
}: LinkBoxProps) => {
  return (
    <S.StyledTargetBlank
      href={getLink ? getLink(link) : undefined}
      onClick={() => {
        setShouldDeleteView(false);
        // if no link out, then copy the embed code
        if (!getLink) {
          copyToClipboard(
            `<iframe src="${window.location.href}" style="border:none;height:1024px;width:100%">`
          );
          toast('Copied to clipboard');
          Analytics.track('Report Iframe Embedd Link Clicked', {
            reportId,
          });
        } else {
          Analytics.track('Share Report Social Link Clicked', {
            reportId,
            social: name,
          });
        }
      }}>
      <S.LinkBoxContainer>
        <S.IconCircle>
          <Icon name={icon} />
        </S.IconCircle>
        {label}
      </S.LinkBoxContainer>
    </S.StyledTargetBlank>
  );
};

export const ShareLinks = ({
  currentPreviewFriendlyURL,
  magicLinkURL,
  normalLinkURL,
  reportId,
  setShouldDeleteView,
}: {
  currentPreviewFriendlyURL: string | undefined;
  magicLinkURL: string | undefined;
  normalLinkURL: string;
  reportId: string;
  setShouldDeleteView: (b: boolean) => void;
}) => {
  return (
    <S.ShareLinksContainer>
      {LINKS.map(linkContent => (
        <LinkBox
          {...linkContent}
          key={linkContent.label}
          link={currentPreviewFriendlyURL || magicLinkURL || normalLinkURL}
          reportId={reportId}
          setShouldDeleteView={setShouldDeleteView}
        />
      ))}
    </S.ShareLinksContainer>
  );
};
